import styled from "styled-components";

export const ProductWrapper = styled.div``;
